import styled from 'styled-components';
import { CalciteStepper, CalciteStepperItem } from 'components/Calcite';

export const StyledStepperContainer = styled.div`
  padding: 2rem;
  flex-grow: 4;
  box-sizing: border-box;
  width: 80%;
  border: none;
  min-height: 100%;
  background-color: ${({ theme }) => theme.color.background};
`;

export const StyledStepContentContainer = styled.div`
  box-sizing: border-box;
  margin-top: 2rem;
`;

export const StyledStepper = styled(CalciteStepper)`
  padding-bottom: 1rem;
`;

export const StyledStepperItem = styled(CalciteStepperItem)`
  --calcite-opacity-disabled: 1;
`;
